document.addEventListener('DOMContentLoaded', () => {
  const quoteForm = document.querySelector('[data-quote-form]');
  if (!quoteForm) return;

  const WORKER_URL = 'https://alib-deviz-worker.alin-dobrita.workers.dev/deviz';

  function rentalDays() {
    const start = document.querySelector('[data-rental-start]')?.value || '';
    const end = document.querySelector('[data-rental-end]')?.value || '';
    if (!start || !end) return 1;

    const startDate = new Date(start + 'T00:00:00');
    const endDate = new Date(end + 'T00:00:00');
    const diff = Math.ceil((endDate - startDate) / 86400000);

    return Math.max(1, diff);
  }

  function getDiscountCode() {
    const inputCode =
      document.querySelector('[data-shopify-discount-input]')?.value?.trim() || '';

    const savedCode =
      localStorage.getItem('alib-discount-code')?.trim() || '';

    return (inputCode || savedCode).toUpperCase();
  }

  function showQuoteMessage(message, isError) {
    let messageBox = document.querySelector('[data-quote-confirmation]');

    if (!messageBox) {
      messageBox = document.createElement('div');
      messageBox.setAttribute('data-quote-confirmation', '');
      quoteForm.prepend(messageBox);
    }

    messageBox.hidden = false;
    messageBox.textContent = message;
    messageBox.style.marginBottom = '14px';
    messageBox.style.padding = '12px 14px';
    messageBox.style.borderRadius = '10px';
    messageBox.style.fontWeight = '700';
    messageBox.style.background = isError ? '#ffe8e8' : '#e8f8ed';
    messageBox.style.color = isError ? '#a40000' : '#12652c';
    messageBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  async function fetchCartItemCount() {
    try {
      const cart = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      }).then((response) => response.json());

      return cart.item_count || 0;
    } catch (error) {
      return null;
    }
  }

  async function clearCartAfterSuccess() {
    for (let attempt = 0; attempt < 2; attempt += 1) {
      try {
        await fetch('/cart/clear.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          cache: 'no-store',
          credentials: 'same-origin'
        });
      } catch (error) {}

      const itemCount = await fetchCartItemCount();

      if (itemCount === 0) break;
    }

    try {
      await fetch('/discount/REMOVE', {
        method: 'GET',
        redirect: 'follow',
        credentials: 'include',
        cache: 'no-store'
      });
    } catch (error) {}

    localStorage.removeItem('alib-rental-start');
    localStorage.removeItem('alib-rental-end');
    localStorage.removeItem('alib-discount-code');

    document.querySelectorAll('.pana2-cart span').forEach((badge) => {
      badge.textContent = '0';
    });
  }

  quoteForm.addEventListener('submit', async (event) => {
    event.preventDefault();

    const submitButton = quoteForm.querySelector('button[type="submit"]');
    const originalButtonText = submitButton?.textContent || 'Trimite';

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Se trimite...';
    }

    const days = rentalDays();
    const products = [];

    document.querySelectorAll('[data-cart-line]').forEach((line) => {
      const quantity = Number(
        line.querySelector('[data-cart-qty]')?.value || 0
      );

      if (quantity <= 0) return;

      const unitCents = Number(line.dataset.unitPrice || 0);
      let image = line.dataset.image || '';

      if (image.startsWith('//')) image = 'https:' + image;

      products.push({
        title: line.dataset.title || '',
        image,
        quantity,
        price_per_day: unitCents / 100
      });
    });

    if (!products.length) {
      showQuoteMessage('Coșul este gol.', true);
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalButtonText;
      }
      return;
    }

    const subtotal = products.reduce(
      (sum, product) =>
        sum + product.price_per_day * product.quantity * days,
      0
    );

    const vat = subtotal * 0.21;
    const total = subtotal + vat;
    const discountCode = getDiscountCode();

    const payload = {
      name:
        quoteForm.querySelector('[name="contact[name]"]')?.value || '',
      email:
        quoteForm.querySelector('[name="contact[email]"]')?.value || '',
      phone:
        quoteForm.querySelector('[name="contact[Telefon]"]')?.value || '',
      cui:
        quoteForm.querySelector('[name="contact[CUI firma]"]')?.value || '',
      message:
        quoteForm.querySelector('[name="contact[body]"]')?.value || '',
      rental_start:
        document.querySelector('[data-rental-start]')?.value || '',
      rental_end:
        document.querySelector('[data-rental-end]')?.value || '',
      rental_days: days,
      products,
      discount_code: discountCode,
      currency: 'EUR',
      total_without_vat: subtotal.toFixed(2),
      vat: vat.toFixed(2),
      total_with_vat: total.toFixed(2)
    };

    try {
      const response = await fetch(WORKER_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok || !result.success) {
        throw new Error(
          result.error ||
          `Devizul nu a fost trimis. Eroare HTTP ${response.status}.`
        );
      }

      showQuoteMessage('Deviz trimis cu succes.', false);
      await clearCartAfterSuccess();
      window.location.href = '/pages/deviz-trimis';
    } catch (error) {
      console.error('Worker error:', error);
      showQuoteMessage(
        error?.message || 'Devizul nu a putut fi trimis.',
        true
      );

      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalButtonText;
      }
    }
  });
});
